import type { NextPage } from 'next';
import { Filters } from './Filters';
import { SearchBar } from './SearchBar';
import { CancelModal } from './CancelModal';
import { useLocalization } from '~/framework';
import { PageContainer } from '~/ui-components';
import { Flex, Text, Stack } from '@chakra-ui/react';
import { QuizSessionTable } from './QuizSessionTable';
import { QuizSessionsProvider } from './QuizSessionsContext';
import { PageTitle, useLoggedInUser } from '~/pages/_shared';
import { ActiveNavItem } from '~/page-components/Layout';
import { TeamModal } from './TeamModal';

const QuizSessions: NextPage = () => {
   const { _js } = useLocalization();
   const { data: user } = useLoggedInUser();
   const canIseeFilters = user?.isUserAnyTeamOwner || user?.permissions.canIViewAllQuizSessions;

   return (
      <>
         <PageTitle>{_js('Quiz Sessions')}</PageTitle>
         <ActiveNavItem value="quizzes" />
         <PageContainer maxW="container.xl">
            <QuizSessionsProvider>
               <Flex align="center" mt="6">
                  <Text variant="title" mb={1}>
                     {_js('Quiz Sessions')}
                  </Text>
               </Flex>

               {canIseeFilters && <TeamModal />}
               {user?.permissions.canIBulkCancelQuizSessions && <CancelModal />}
               {canIseeFilters && (
                  <Stack direction="row" spacing="2" py="6">
                     <Filters />
                     <SearchBar />
                  </Stack>
               )}

               <QuizSessionTable />
            </QuizSessionsProvider>
         </PageContainer>
      </>
   );
};

export default QuizSessions;
